var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitlabIconRgb = function SvgGitlabIconRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.05 184.99"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gitlab-icon-rgb_svg__cls-2{fill:#fc6d26}"))), /*#__PURE__*/React.createElement("g", {
    id: "gitlab-icon-rgb_svg__LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.83 170.73-.27-.69-26.14-68.22a6.8 6.8 0 0 0-2.69-3.24 7 7 0 0 0-8 .43 7 7 0 0 0-2.32 3.52l-17.65 54h-71.47l-17.65-54a6.86 6.86 0 0 0-2.32-3.53 7 7 0 0 0-8-.43 6.87 6.87 0 0 0-2.69 3.24L97.44 170l-.26.69a48.54 48.54 0 0 0 16.1 56.1l.09.07.24.17 39.82 29.82 19.7 14.91 12 9.06a8.07 8.07 0 0 0 9.76 0l12-9.06 19.7-14.91 40.06-30 .1-.08a48.56 48.56 0 0 0 16.08-56.04",
    style: {
      fill: "#e24329"
    },
    transform: "translate(-93.973 -97.517)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m188.857 73.213-.27-.69a88.3 88.3 0 0 0-35.15 15.8l-57.41 43.41c19.55 14.79 36.57 27.64 36.57 27.64l40.06-30 .1-.08a48.56 48.56 0 0 0 16.1-56.08",
    className: "gitlab-icon-rgb_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m153.43 256.89 19.7 14.91 12 9.06a8.07 8.07 0 0 0 9.76 0l12-9.06 19.7-14.91S209.55 244 190 229.25c-19.55 14.75-36.57 27.64-36.57 27.64",
    style: {
      fill: "#fca326"
    },
    transform: "translate(-93.973 -97.517)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.607 88.323a88.2 88.2 0 0 0-35.14-15.84l-.26.69a48.54 48.54 0 0 0 16.1 56.1l.09.07.24.17 39.82 29.82 36.57-27.64Z",
    className: "gitlab-icon-rgb_svg__cls-2"
  }))));
};
export default SvgGitlabIconRgb;